import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { Button } from '@mui/material';
import { isIOSApp } from 'webui/utils/version';
import { CheckCircleOutlineRounded } from '@mui/icons-material';
import { OnAutoPaymentDialog } from 'console/billing/balance-card/auto-payment/on-dialog';
import { OffAutoPaymentDialog } from 'console/billing/balance-card/auto-payment/off-dialog';
import { useAppSelector } from 'shared/hooks/redux/hooks';
import { PaymentMethod } from 'console/billing/types';
import { useBooleanState } from 'shared/hooks/state/boolean';
import { HelpIcon } from 'console/shared/components/fields/help-icon';
export const AutoPayBalanceButton = memo(function AutoPayBalanceButton() {
    const is_demo = useAppSelector((state) => state.account.is_demo);
    const auto_payment = useAppSelector((state) => state.billing.settings.data.auto_payment);
    const pay_only_invoice = useAppSelector((state) => state.billing.settings.data.last_payment_method ===
        PaymentMethod.invoice);
    const [opened_add, close_add, open_add] = useBooleanState(false);
    const [opened_off, close_off, open_off] = useBooleanState(false);
    if (isIOSApp() || is_demo || pay_only_invoice) {
        return null;
    }
    return (_jsxs(_Fragment, { children: [auto_payment ? (_jsx(Button, { variant: "outlined", color: "success", startIcon: _jsx(CheckCircleOutlineRounded, {}), onClick: open_off, children: "\u0410\u0432\u0442\u043E\u043F\u043B\u0430\u0442\u0451\u0436" })) : (_jsxs(_Fragment, { children: [_jsx(Button, { onClick: open_add, children: "\u0410\u0432\u0442\u043E\u043F\u043B\u0430\u0442\u0451\u0436" }), _jsx(HelpIcon, { help_id: 'autopay' })] })), _jsx(OnAutoPaymentDialog, { open: opened_add, onClose: close_add }), _jsx(OffAutoPaymentDialog, { open: opened_off, onClose: close_off, auto_payment: auto_payment })] }));
});
